import useHasura from '@/hooks/useHasura'
import { Survey } from '@/ts/Survey'

import { GET_CREATOR_SURVEYS } from '../queries/Surveys'

function useCreatorSurveys(creator_id: number) {
  const { data, ...rest } = useHasura<Data>(
    'creator-surveys',
    GET_CREATOR_SURVEYS,
    {
      variables: { creator_id },
    }
  )

  return { surveys: data?.surveys, ...rest }
}

interface Data {
  surveys: Survey[]
}

export default useCreatorSurveys
